var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMomentum({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 134 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Momentum"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1885 109.823L24.7326 84.3668C25.0155 86.3467 21.5506 90.8486 19.7829 92.8521L42.0567 115.126C42.6224 112.863 47.7136 110.648 50.1885 109.823Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1902 77.6493L57.2595 49.7185C43.6831 58.7695 33.4536 71.6389 30.0359 76.9422L58.6737 105.58C69.4218 98.2261 80.8297 83.8954 85.1902 77.6493Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5402 78.7099L4.22651 77.2957C0.832393 65.982 23.3184 56.7896 34.9857 53.6076C27.0661 57.0017 18.7222 71.7567 15.5402 78.7099Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0793 68.1033L66.8055 45.8295C71.0481 39.3241 82.9511 39.1119 88.3722 39.8191L99.6859 28.5053C106.191 28.2225 106.875 32.8658 106.403 35.2229L95.0897 46.5366C97.3525 55.5875 92.0256 64.6856 89.0793 68.1033Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.906 129.975L55.1382 118.308C55.9867 121.985 74.1122 107.348 83.0689 99.5696C71.1895 127.288 60.6772 131.389 56.906 129.975Z",
    fill: "#135FC2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1906",
    cx: 58.3994,
    cy: 77.1084,
    r: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1907",
    cx: 58.3994,
    cy: 77.1084,
    r: 5,
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M6.18267 121.833L18.4653 110.737L14.5281 106.379L2.24546 117.474L6.18267 121.833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M12.7442 128.31L25.0268 117.214L21.0896 112.856L8.80699 123.952L12.7442 128.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M40.6526 110.164L23.6816 93.8536L17.1459 99.054L34.1168 115.365L40.6526 110.164Z",
    fill: "#135FC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomentum);
export default __webpack_public_path__ + "static/media/Momentum.eb4d92766d5d87e1ac81afb8bd250d5c.svg";
export { ForwardRef as ReactComponent };